import { Font, StyleSheet } from '@react-pdf/renderer';
import { sizing, spacing } from 'styles/helpers';
import { theme } from 'styles/theme';

Font.register({
  family: 'Google Sans Regular',
  fonts: [
    { src: require('fonts/GoogleSans-Regular.ttf') },
  ],
});

Font.register({
  family: 'Google Sans Medium',
  fonts: [
    { src: require('fonts/GoogleSans-Medium.ttf') },
  ],
});

Font.register({
  family: 'Google Sans SemiBold',
  fonts: [
    { src: require('fonts/GoogleSans-SemiBold.ttf') },
  ],
});

Font.register({
  family: 'Google Sans Bold',
  fonts: [
    { src: require('fonts/GoogleSans-Bold.ttf') },
  ],
});

const styles = StyleSheet.create({
  page: {
    color: theme.colors.textSecondary,
    fontFamily: 'Google Sans Regular',
    paddingBottom: `${spacing['4xl']}`,
  },
  productName: {
    color: theme.colors.primary,
    fontFamily: 'Google Sans SemiBold',
    fontSize: sizing(5),
    margin: `${spacing['2xs']} ${spacing.m}`,
  },
  wrapper: {
    flexDirection: 'row',
    padding: `0 ${spacing.m}`,
  },
  contentLeft: {
    flex: 1,
    marginRight: 10,
  },
  contentRight: {
    flex: 1,
    marginLeft: 10,
  },
});

export default styles;
